import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-278d92c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loadingSpinner relative w-full h-full flex flex-col items-center justify-center animate-fade-in-tooltip font-basier text-dark-gray" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader ease-linear rounded-full border-6 border-t-6 h-24 w-24" }, null, -1))
const _hoisted_3 = { class: "font-semibold absolute text-sm text-center w-20 h-full flex items-center" }

type Props = {
    text?: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    text: { type: String, required: false, default: 'Pobieranie danych' }
  },
  setup(__props: any) {

const props = __props as { text: string }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", _hoisted_3, _toDisplayString(props.text), 1)
  ]))
}
}

})